/**
 * Date Format
 *
 * Date display format patterns (unicode CLDR / date-fns notation).
 */
export const DateFormat = {
  DD_MM_YYYY_DOT: 'dd.MM.yyyy', // Czech / Slovak / German: 31.12.2024
  DD_MM_YYYY_SLASH: 'dd/MM/yyyy', // UK / most of Europe: 31/12/2024
  MM_DD_YYYY_SLASH: 'MM/dd/yyyy', // US: 12/31/2024
  YYYY_MM_DD: 'yyyy-MM-dd', // ISO 8601: 2024-12-31
  DD_MM_YYYY_DASH: 'dd-MM-yyyy', // Dash variant: 31-12-2024
  D_M_YYYY_DOT: 'd.M.yyyy', // Czech short: 1.1.2024
  YYYY_MM_DD_DOT: 'yyyy.MM.dd', // Hungary / Korea: 2024.12.31
  YYYY_MM_DD_SLASH: 'yyyy/MM/dd' // Japan / China: 2024/12/31
} as const;

export type DateFormat = (typeof DateFormat)[keyof typeof DateFormat];
